module.exports = __webpack_public_path__ + "media/application/images/svgs/aperture-0c2e232eab591f8377227d6b30e40947.svg";